import styles from "./ContactSection.module.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";

import phoneIcon from "../../assets/contacts/icons/phone-icon.svg";
import mailIcon from "../../assets/contacts/icons/send-icon.svg";
import clockIcon from "../../assets/contacts/icons/clock-icon.svg";

const ContactSection = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    message: "",
  });

  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSending(true);
    setIsSent(false);
    setError(false);

    try {
      const form = new FormData();

      form.append("name1", formData.name);
      form.append("email1", formData.email);
      form.append("message1", formData.message);
      form.append("contact1", formData.phone);

      const response = await fetch("/contact_form.php", {
        method: "POST",
        body: form,
      });

      const text = await response.text();

      // PHP връща plain text, не JSON
      if (text.includes("Заявката ви е получена")) {
        setIsSent(true);

        setFormData({
          name: "",
          phone: "",
          email: "",
          company: "",
          message: "",
        });
      } else {
        setError(true);
      }

    } catch (err) {
      setError(true);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div id="contact" className={styles.wrapper}>

      <header className={styles.header}>
        <h2>{t("contact.header.title")}</h2>
        <p>{t("contact.header.subtitle")}</p>
      </header>

      <div className={styles.grid}>

        {/* FORM */}
        <div className={styles.card}>
          <h3>{t("contact.form.title")}</h3>

          <form className={styles.form} onSubmit={handleSubmit}>

            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={t("contact.form.fields.name")}
              required
            />

            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder={t("contact.form.fields.phone")}
              required
            />

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t("contact.form.fields.email")}
              required
            />

            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder={t("contact.form.fields.company")}
            />

            <textarea
              rows="4"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder={t("contact.form.fields.message")}
              required
            />

            <button type="submit" disabled={isSending}>
              {isSending
                ? t("contact.form.sending")
                : t("contact.form.submit")}
            </button>

            {isSent && (
              <p className={styles.success}>
                {t("contact.form.success")}
              </p>
            )}

            {error && (
              <p className={styles.error}>
                {t("contact.form.error")}
              </p>
            )}

          </form>
        </div>

        {/* INFO */}
        <div className={styles.info}>
          <div className={styles.card}>
            <h3>{t("contact.departments.sales.title")}</h3>

            <ul>
              <li>
                <img src={phoneIcon} alt="" />
                <span>{t("contact.departments.sales.phones")}</span>
              </li>

              <li>
                <img src={mailIcon} alt="" />
                <span>{t("contact.departments.sales.email")}</span>
              </li>

              <li>
                <img src={clockIcon} alt="" />
                <span>{t("contact.departments.sales.hours")}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* MAP */}
      <div className={styles.map}>
        <h2>{t("contact.map.title")}</h2>
        <p>{t("contact.map.address")}</p>

        <iframe
          title="Google Maps"
          loading="lazy"
          allowFullScreen
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2933.5291179482256!2d23.3292!3d42.671333!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85acd2361deb%3A0x5b880219810fb508!2sUCS%20Rkeeper!5e0!3m2!1sbg!2sbg!4v1769689499030!5m2!1sbg!2sbg"
        />
      </div>

    </div>
  );
};

export default ContactSection;